import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import { careers } from "@/data/site";

const EASE = [0.22, 1, 0.36, 1];

export default function Careers() {
    return (
        <div data-testid="page-careers">
            <PageHeader
                eyebrow="Careers — a small team"
                title={<>Build with us, <em className="italic text-lime">slowly.</em></>}
                lead="We are seventy-two. We hire twice a year — when someone extraordinary walks into the studio, or when a project needs a specialist we don't have."
            />
            <section className="relative bg-forest-950 py-16 md:py-24">
                <div className="mx-auto max-w-[1440px] px-6 md:px-10">
                    <div className="font-mono-mini text-[10px] tracking-[0.32em] uppercase text-lime mb-8">
                        Open — 05 roles
                    </div>
                    <ul className="divide-y divide-white/10 border-y border-white/10">
                        {careers.map((c, i) => (
                            <motion.li
                                key={c.title}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-10% 0px" }}
                                transition={{ duration: 0.85, ease: EASE, delay: i * 0.05 }}
                                data-testid={`career-row-${i}`}
                            >
                                <a
                                    href="mailto:careers@kliving.co?subject=Application"
                                    className="group grid grid-cols-12 items-center py-8 md:py-10 gap-6"
                                >
                                    <div className="col-span-2 md:col-span-1 font-mono-mini text-[10px] tracking-[0.32em] uppercase text-lime">
                                        {String(i + 1).padStart(2, "0")}
                                    </div>
                                    <div className="col-span-10 md:col-span-6">
                                        <h3 className="font-serif-display text-2xl md:text-3xl leading-tight text-ivory group-hover:text-lime transition-colors">
                                            {c.title}
                                        </h3>
                                    </div>
                                    <div className="col-span-6 md:col-span-2 font-mono-mini text-[10px] tracking-[0.28em] uppercase text-ivory/60">
                                        {c.location}
                                    </div>
                                    <div className="col-span-4 md:col-span-2 font-mono-mini text-[10px] tracking-[0.28em] uppercase text-ivory/60">
                                        {c.type}
                                    </div>
                                    <div className="col-span-2 md:col-span-1 justify-self-end">
                                        <span className="inline-flex h-11 w-11 items-center justify-center border border-ivory/20 text-ivory/80 group-hover:bg-lime group-hover:border-lime group-hover:text-forest-900 transition-colors">
                                            <ArrowUpRight size={16} strokeWidth={1.5} />
                                        </span>
                                    </div>
                                </a>
                            </motion.li>
                        ))}
                    </ul>

                    <div className="mt-20 grid grid-cols-1 md:grid-cols-12 gap-10">
                        <div className="md:col-span-5">
                            <div className="font-mono-mini text-[10px] tracking-[0.32em] uppercase text-lime mb-4">
                                Nothing fits?
                            </div>
                            <h3 className="font-serif-display text-3xl md:text-4xl leading-tight text-ivory">
                                Write to us anyway.
                            </h3>
                        </div>
                        <div className="md:col-span-6 text-ivory/70 leading-relaxed">
                            <p>
                                We keep a rolling shortlist for future hires. If you are an
                                architect, engineer, landscape designer or artisan who cares about
                                the craft, we would like to know.
                            </p>
                            <a
                                href="mailto:careers@kliving.co"
                                data-testid="careers-open-email"
                                className="mt-6 inline-flex items-center gap-3 font-mono-mini text-[11px] tracking-[0.32em] uppercase text-ivory hover-underline hover:text-lime"
                            >
                                careers@kliving.co <ArrowUpRight size={16} />
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
